<template>
  <div class="TableOrderList">
    <!-- 保单列表  搜索有数据 -->
    <div class="hasData" v-if="isShow">
      <el-table
        empty-text=" "
        v-loading="loading"
        :data="list"
        stripe
        :row-class-name="TableRow"
        :header-cell-style="thClass"
        :cell-style="{ color: '#666666', height: '80px' }"
      >
        <el-table-column label="订单编号" prop="orderSn" width="182px">
        </el-table-column>
        <el-table-column label="投保地块" width="172px">
          <template slot-scope="scope">
            {{ scope.row.farmInsureOrderLandCount }}个地块
            <span class="AcreMianJi">({{ scope.row.acre }}亩)</span>
          </template>
        </el-table-column>
        <el-table-column label="投保作物" width="182px">
          <template slot-scope="scope">
            <div
              class="multi-ellipsis--l2 noDunhaoFather"
              :title="scope.row.cropGroupNameSet"
            >
              {{ scope.row.cropGroupNameSet.join("、") }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="自缴保费" width="150px">
          <template slot-scope="scope">
            {{ scope.row.selfPremium ? scope.row.selfPremium + "元" : "-" }}
          </template>
        </el-table-column>
        <el-table-column label="状态" width="100px">
          <template slot-scope="scope">
            <!-- `orderStatus` 订单状态： 10待付款、 20已付款、 30、已取消',40：出单中 -->
            <span :class="orderClolor[scope.row.orderStatus]">
              {{ setOrderS[scope.row.orderStatus] }}</span
            >
          </template>
        </el-table-column>

        <el-table-column label="状态更新时间" width="165px">
          <template slot-scope="scope">
            {{ scope.row.updateTime | formatDate("yyyy-MM-dd hh:mm") }}
          </template>
        </el-table-column>

        <el-table-column label="操作" :width="width270">
          <template slot-scope="scope">
            <el-button
              class="button14"
              @click="checkContent(scope.row)"
              type="text"
              size="small"
              >查看</el-button
            >
            <el-button
              class="button14"
              @click="PayMoney(scope.row)"
              type="text"
              size="small"
              v-if="scope.row.orderStatus === '10' && scope.row.payType === 1"
              >支付</el-button
            >

            <el-button
              class="button14"
              @click="printPay(scope.row)"
              type="text"
              size="small"
              v-if="scope.row.orderStatus === '10' && scope.row.payType === 0"
              >打印付款通知书</el-button
            >

            <el-button
              class="button14"
              type="text"
              size="small"
              @click="cancelOrder(scope.row)"
              :loading="scope.row.btnStatus"
              :disabled="scope.row.btnStatus"
              v-if="scope.row.orderStatus === '10'"
              >取消订单</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 搜索后无数据 -->
    <div class="noDataImg" v-else>
      <div class="imgNo">
        <img src="~@/assets/images/insuranceImg/nodataImg.png" alt="" />
      </div>
      <p style="color: #333">未找到符合条件的数据</p>
    </div>
  </div>
</template>

<script>
import sameIn from "@/mixins/listsdetails.js";

import { order_state } from "@/confing/map_tab.js";

import {
  delOrdercancel,
  getPayUrl,
  getofflinePayment,
} from "@/api/request/snkd.produce";

export default {
  name: "TableOrderList",
  mixins: [sameIn],
  data() {
    return {
      setOrderS: order_state,
      orderClolor: {
        10: "noPaid",
        20: "havePaid",
        30: "closePaid",
        40: "havePaid",
      },
    };
  },
  props: {
    list: {
      type: Array,
      required: true,
    },
    isShow: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    width270() {
      let res = this.list.some((ele) => {
        if (ele.orderStatus === "10" && ele.payType === 0) {
          return "270px";
        }
      });
      if (res) {
        return "270px";
      } else {
        return "";
      }
    },
  },
  methods: {
    // 取消订单
    cancelOrder(row) {
      this.$confirm("确定取消保险订单?", "提示", {
        showClose: true,
        type: "warning",
        customClass: "message-box-height",
      }).then(async () => {
        row.btnStatus = true;
        const { respCode } = await delOrdercancel({
          id: row.id,
        });
        if (respCode === 0) {
          this.$message({
            type: "success",
            message: "取消成功!",
          });
          this.$nextTick(() => {
            row.btnStatus = false;
          });

          // 触发父组件;
          this.$emit("alginGet");
        } else {
          row.btnStatus = false;
        }
      });
    },

    checkContent(row) {
      this.$router.push({
        name: "DetailsIndex",
        query: {
          type: 2,
          id: row.id,
        },
      });
    },
    // 获取支付链接
    async PayMoney(row) {
      const { respCode, obj } = await getPayUrl({
        id: row.id,
      });

      if (respCode === 0) {
        window.open(obj.payUrl);
        this.$confirm("是否完成付款？已完成付款请刷新页面", "提示", {
          confirmButtonText: "刷新",
          cancelButtonText: "取消",
          type: "warning",
          customClass: "message-box-height",
        }).then(() => {
          this.$emit("alginGet");
          this.$message({
            type: "success",
            message: "刷新成功!",
          });
        });
      }
    },

    // 获取付款通知书 打印 链接
    async printPay(row) {
      console.log("打印付款通知书--- 获取到打印的文件");
      const { respCode, obj } = await getofflinePayment({
        id: row.id,
      });
      if (respCode === 0) {
        window.open(obj);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.hasData {
  height: 100%;
}
.tishiText {
  width: 200px;
}

.width270 {
  width: 270px;
}
</style>
